import { useState, useEffect } from 'preact/hooks';
import * as queries from 'utils/storefront/queries';
import { edgesToNodes } from 'utils/storefront/format-resource';
import Storefront from 'utils/storefront';

const useProductSiblings = (product) => {
  const [products, setProducts] = useState([product]);
  const storefront = Storefront.getInstance();

  useEffect(() => {
    const getProducts = async () => {
      let response = null;
      if (product.productType === 'Outfit') {
        if (!product.look_products?.value) {
          return [];
        }
        response = await storefront.request({
          query: queries.getProductsByIds,
          variables: {
            ids: JSON.parse(product.look_products.value),
          },
        });
      } else {
        response = await storefront.request({
          query: queries.productsByTag(product.groupId, 40),
        });
      }

      if (!response?.data) {
        // eslint-disable-next-line no-console
        console.error(
          'utils/product-siblings.js: Storefront API request failed',
          response,
        );
        return [];
      }

      return edgesToNodes(
        response.data.products || response.data.nodes,
        'product',
      );
    };
    if (product.groupId || product.productType === 'Outfit') {
      getProducts().then((items) =>
        setProducts(
          items.map((item) => ({
            ...item,
            lazyLoadDesktop: product.lazyLoadDesktop,
          })),
        ),
      );
    }
  }, []);

  return products;
};

export default useProductSiblings;
